export const routes = [
  {
    path: "/observagov/compras",
    name: "observagov.compras",
    component: () => import(/* webpackChunkName: "observagov-compras" */ "./Painel.vue"),
    meta: { requiresAuth: true },
  },
];
